export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');
  const iconBase = window.globalConfig?.iconBasePath || '/brand-assets/default/icons/';

  favicons.forEach(favicon => {
    const newFileName = `${iconBase}favicon-badge-${favicon.sizes[[0]]}.png`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');
  const iconBase = window.globalConfig?.iconBasePath || '/brand-assets/default/icons/';

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        const oldFileName = `${iconBase}favicon-${favicon.sizes[[0]]}.png`;
        favicon.href = oldFileName;
      });
    }
  });
};
